/*
 * @Author: zouyaoji@https://github.com/zouyaoji
 * @Date: 2021-09-16 09:28:13
 * @LastEditTime: 2022-03-30 10:54:26
 * @LastEditors: zouyaoji
 * @Description:
 * @FilePath: \vue-cesium@next\packages\components\geometries\frustum\index.ts
 */
import { VcComponentInternalInstance, VcComponentPublicInstance, VcPosition, VcReadyObject } from 'casc-cesium-utils/types'
import { defineComponent, getCurrentInstance, createCommentVNode } from 'vue'
import { useGeometries } from 'casc-cesium-composables'
import { kebabCase } from 'casc-cesium-utils/util'
import { frustum, origin, orientation, vertexFormat } from 'casc-cesium-utils/cesium-props'
import { commonEmits } from 'casc-cesium-utils/emits'
export const frustumGeometryProps = {
  ...frustum,
  ...origin,
  ...orientation,
  ...vertexFormat
}
export default defineComponent({
  name: 'VcGeometryFrustum',
  props: frustumGeometryProps,
  emits: commonEmits,
  setup(props, ctx) {
    // state
    const instance = getCurrentInstance() as VcComponentInternalInstance
    instance.cesiumClass = 'FrustumGeometry'
    useGeometries(props, ctx, instance)

    return () => createCommentVNode(kebabCase(instance.proxy?.$options.name || 'v-if'))
  }
})

export type VcGeometryFrustumProps = {
  /**
   * The frustum.
   */
  frustum: Cesium.PerspectiveFrustum | Cesium.OrthographicFrustum
  /**
   * The origin of the frustum.
   */
  origin: VcPosition
  /**
   * The orientation of the frustum.
   */
  orientation: Cesium.Quaternion
  /**
   * The vertex attributes to be computed.
   */
  vertexFormat?: Cesium.VertexFormat
  /**
   * Triggers before the VcGeometryFrustum is loaded.
   */
  onBeforeLoad?: (instance: VcComponentInternalInstance) => void
  /**
   * Triggers when the VcGeometryFrustum is successfully loaded.
   */
  onReady?: (readyObject: VcReadyObject) => void
  /**
   * Triggers when the component load failed.
   */
  onUnready?: (e: any) => void
  /**
   * Triggers when the VcGeometryFrustum is destroyed.
   */
  onDestroyed?: (instance: VcComponentInternalInstance) => void
}

export type VcGeometryFrustumRef = VcComponentPublicInstance<VcGeometryFrustumProps>
